import axios from 'axios';
import store from '../store';
import { Toast } from 'vant';

let prefix = store.getters.userInfo.url || '';
let openid = store.getters.userInfo.openid || '';
let lot_id = store.getters.userInfo.lot_id || '';
let user_id = store.getters.userInfo.user_id || '';
let wx_zfb = store.getters.userInfo.wx_zfb || '';

const service = axios.create({
  baseURL: `${prefix}/api`,
  timeout: 30000,
});

const errorHandler = ({ response } = {}) => {
  const {
    status,
    data,
    data: { code },
  } = response;
  if (status === 400 || status === 500 || code === 400 || code === 500) {
    Toast(data.message || '服务器内部发生错误，请稍后再试');
  } else {
    Toast(data.message);
  }
  return Promise.reject(data);
};

service.interceptors.request.use(
  ({ headers, params = {}, data = {}, ...rest }) => {
    if (data instanceof FormData) {
      return {
        headers: { ...headers },
        params,
        data,
        ...rest,
      };
    }
    return {
      ...rest,
      params: {
        lot_id: lot_id || undefined,
        wx_zfb: wx_zfb || undefined,
        user_id: user_id || undefined,
        openid: openid || undefined,
        ...params,
      },
      data: {
        lot_id: lot_id || undefined,
        wx_zfb: wx_zfb || undefined,
        user_id: user_id || undefined,
        openid: openid || undefined,
        ...data,
      },
      headers: { ...headers },
    };
  }
);

service.interceptors.response.use(response => {
  if (response.data.code >= 300) {
    return errorHandler({ response });
  }
  return response.data;
}, errorHandler);

export default service;
